document.addEventListener('DOMContentLoaded',  function() {
    $('#show_vat_toggle').on("change", VATtoggleChanged);
});

function VATtoggleChanged() {
    let vat_toggle = $('#show_vat_toggle');
    // debugger;
    if (vat_toggle.prop('checked')) {
        $(vat_toggle).closest('.vat-toggle').find('label.with-vat-toggle__label').css("display", "block");
        $(vat_toggle).closest('.vat-toggle').find('label.no-vat-toggle__label').css("display", "none");
    } else {
        $(vat_toggle).closest('.vat-toggle').find('label.no-vat-toggle__label').css("display", "block");
        $(vat_toggle).closest('.vat-toggle').find('label.with-vat-toggle__label').css("display", "none");
    }

    dispatchVatToggleChangeEvent();
}

function dispatchVatToggleChangeEvent() {
    // debugger;
    let vat_toggle = $('#show_vat_toggle');
    let form = document.forms[$(vat_toggle).attr('form')].id;
    form.dispatchEvent(new CustomEvent("vat_toggle:change", {
        bubbles: true,
        detail: {
            with_vat: vat_toggle.prop('checked')
        }
    }));
}